/* eslint-disable @typescript-eslint/no-unsafe-assignment */
// 提现超次手续费
import { Vue, Component } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { ApplyProductData } from '@/api/apply-product/types';
import { contractPage } from '@/components/contract';
import FormField from '@/components/form-field';

const detailUrl = require('@/assets/contracts/chaocishouxufei.html');

const style = require('./index.module.scss') as Dictionary;

const ApplyProductStore = namespace('applyProduct');

@Component
export default class RepaymentRate extends Vue {
  @ApplyProductStore.State product!: ApplyProductData | undefined;

  private get repaymentRate(): number {
    return this.product
      ? Number(
        this.product.productInfo && this.product.productInfo.repaymentRate,
      ) * 100
      : 0;
  }

  private render() {
    return this.repaymentRate > 0 ? (
      <div class={style.repaymentRate}>
        <FormField name="超次手续费" isActive={false} showArrow={false}>
          <span
            slot="middle"
            class={style.questionIcon}
            onClick={this.showDetail.bind(this)}
          />
          <span>{this.repaymentRate}%</span>
        </FormField>
      </div>
    ) : null;
  }

  private showDetail() {
    contractPage.open(detailUrl);
  }
}
